var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 7.49754C2.32884 7.49754 2.96452 7.76085 3.43321 8.22954C3.9019 8.69823 4.16521 9.33391 4.16521 9.99674C4.16521 10.6596 3.9019 11.2952 3.43321 11.7639C2.96452 12.2326 2.32884 12.4959 1.66602 12.4959V14.1621C1.66602 14.6039 1.84155 15.0277 2.15401 15.3402C2.46647 15.6527 2.89026 15.8282 3.33215 15.8282H16.6612C17.1031 15.8282 17.5269 15.6527 17.8393 15.3402C18.1518 15.0277 18.3273 14.6039 18.3273 14.1621V12.4959C17.6645 12.4959 17.0288 12.2326 16.5601 11.7639C16.0914 11.2952 15.8281 10.6596 15.8281 9.99674C15.8281 9.33391 16.0914 8.69823 16.5601 8.22954C17.0288 7.76085 17.6645 7.49754 18.3273 7.49754V5.83141C18.3273 5.38953 18.1518 4.96574 17.8393 4.65328C17.5269 4.34082 17.1031 4.16528 16.6612 4.16528H3.33215C2.89026 4.16528 2.46647 4.34082 2.15401 4.65328C1.84155 4.96574 1.66602 5.38953 1.66602 5.83141V7.49754Z",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8301 4.16528V5.83141",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8301 14.1621V15.8282",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8301 9.16382V10.8299",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon03.f28981177741a0425136ed8aee9fb4cf.svg";
export { ForwardRef as ReactComponent };